/**
 * Welcome flow template.
 *
 * Centered single-column layout used by the welcome screen and the
 * boot-time AppLoader. Fills the space below WordPress admin notices
 * without covering their messages or actions.
 *
 * @package LiquidWeb\Harbor
 */
import { type ReactNode } from 'react';
import { __ }             from '@wordpress/i18n';
import { NexcessLogo }    from '@/components/atoms/NexcessLogo';

interface WelcomeShellProps {
    children?: ReactNode;
}

/**
 * @since 1.3.0
 */
export function WelcomeShell( { children }: WelcomeShellProps ) {
    return (
        <div className="relative h-full w-full max-w-full flex flex-col items-center justify-center overflow-y-auto bg-white">
            <div className="w-full max-w-104">
                <div className="flex flex-col items-center gap-1.5 text-center">
                    <NexcessLogo className="w-18 h-18" />
                    <div className="-space-y-1 mb-4">
                        <h1 className="text-2xl leading-8 font-semibold tracking-wide p-0 text-neutral-950">
                            { __( 'Nexcess Licensing', '%TEXTDOMAIN%' ) }
                        </h1>
                    </div>
                </div>
				<div className="space-y-8">
					{ children }
				</div>
            </div>
        </div>
    );
}
